import { render, staticRenderFns } from "./inquires-search.vue?vue&type=template&id=6bf16b42&"
import script from "./inquires-search.vue?vue&type=script&lang=js&"
export * from "./inquires-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports